export default "__VITE_ASSET__DC_8SdJE__"